(() => {
  if (window.goodkinSavingsChartLoaded) return;
  window.goodkinSavingsChartLoaded = true;
  const initialize = root => {
    if (root.dataset.gksReady) return;
    root.dataset.gksReady = 'true';
    const slider = root.querySelector('[data-gks-frequency]');
    let price = Math.max(0, Number(root.dataset.price) / 100 || 0);
    const cost = Math.max(0, Number(root.dataset.cost) || 0);
    const rounding = Math.max(0, Number(root.dataset.rounding) || 0);
    const formatOptions = { style: 'currency', currency: root.dataset.currency || 'USD', currencyDisplay: root.dataset.showCurrency === 'true' ? 'code' : 'narrowSymbol' };
    const wholeMoney = new Intl.NumberFormat(root.dataset.locale || 'en', { ...formatOptions, maximumFractionDigits: 0 });
    const kitMoney = new Intl.NumberFormat(root.dataset.locale || 'en', { ...formatOptions, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const money = (formatter, value) => formatter.formatToParts(value).map(part => part.type === 'currency' && root.dataset.showCurrency !== 'true' ? part.value.replace(/^[A-Za-z]+(?=\$)/, '') : part.value).join('');
    const setMoney = (element, formatter, value) => {
      const parts = money(formatter, value).match(/^(.*?)([\d,]+(?:\.\d+)?)(.*?)$/);
      if (!parts) { element.textContent = money(formatter, value); return; }
      element.replaceChildren(...parts.slice(1).filter(Boolean).map(text => { const span = document.createElement('span'); span.textContent = text; return span; }));
    };
    const update = () => {
      const weeks = Math.max(1, Math.min(8, Number(slider.value) || 1));
      const annual = Math.ceil(52 / weeks) * cost;
      const difference = Math.round((annual - price) * 100) / 100;
      const displayedSavings = rounding > 0 ? Math.floor(Math.max(0, difference) / rounding) * rounding : Math.max(0, difference);
      setMoney(root.querySelector('[data-gks-salon-total]'), wholeMoney, annual);
      setMoney(root.querySelector('[data-gks-kit-price]'), kitMoney, price);
      const scaleMaximum = Math.max(52 * cost, price, 1);
      const setBarHeight = (selector, amount) => {
        const bar = root.querySelector(selector);
        const height = Math.max(0, Math.min(170, amount / scaleMaximum * 170));
        bar.style.height = `${height}px`;
        bar.classList.toggle('gkg-save__bar--short', height < 44);
      };
      setBarHeight('[data-gks-salon-bar]', annual);
      setBarHeight('[data-gks-kit-bar]', price);
      root.querySelector('[data-gks-salon-frequency]').textContent = root.dataset.salonFrequency.replaceAll('[weeks]', String(weeks));
      const frequencyText = root.dataset.sliderFrequency.replaceAll('[weeks]', String(weeks));
      slider.setAttribute('aria-valuetext', frequencyText);
      const label = root.querySelector('[data-gks-frequency-label]');
      const parts = root.dataset.sliderFrequency.split('[weeks]');
      label.replaceChildren();
      parts.forEach((part, index) => {
        if (index) { const number = document.createElement('strong'); number.textContent = String(weeks); label.append(number); }
        label.append(document.createTextNode(part));
      });
      const savings = root.querySelector('[data-gks-savings]');
      const template = difference > 0 ? root.dataset.savingsText : difference < 0 ? root.dataset.negativeText : root.dataset.zeroText;
      savings.replaceChildren();
      template.split('[amount]').forEach((part, index) => {
        if (index) { const amount = document.createElement('span'); setMoney(amount, difference > 0 ? wholeMoney : kitMoney, difference > 0 ? displayedSavings : Math.abs(difference)); savings.append(amount); }
        savings.append(document.createTextNode(part));
      });
    };
    slider.addEventListener('input', update);
    slider.addEventListener('change', update);
    root.gksVariantListener = event => {
      if (!root.isConnected || root.dataset.useProductPrice !== 'true' || event.detail.productId !== root.dataset.productId) return;
      price = Math.max(0, Number(event.detail.price) || 0);
      update();
    };
    document.addEventListener('gkg:variant', root.gksVariantListener);
    update();
  };
  const initializeWithin = target => target.querySelectorAll('[data-gkg-savings-chart]').forEach(initialize);
  initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-gkg-savings-chart]').forEach(root => document.removeEventListener('gkg:variant', root.gksVariantListener)));
})();

